import * as React from "react"
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function DIPDateRangeIcon() {
    return <Box component="span" sx={{ fontSize: 12, color: "text.disabled", pl: 1 }}>
        <IconSeeker icon="chevron-down" />
    </Box>
}